export default __webpack_public_path__ + "static/media/logo.55f6cb09.svg";